import { render } from "./ContentBuilderFormEditor.vue?vue&type=template&id=c6774cd8"
import script from "./ContentBuilderFormEditor.vue?vue&type=script&lang=js"
export * from "./ContentBuilderFormEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__